import Vue from 'vue';
import UIHead from './vue-ui/head.vue';
import UIMid from './vue-ui/mid.vue';
import UIFoot from './vue-ui/foot.vue';
import UISidebar from './vue-ui/sidebar.vue';
import UIHelp from './vue-ui/help.vue';
import UITreeBack from './vue-ui/tree-back.vue';
import UITreeHead from './vue-ui/tree-head.vue';
import UITreeSide from './vue-ui/tree-side.vue';
import UITreeContent from './vue-ui/tree-content.vue';
import UITreeSidebar from './vue-ui/tree-sidebar.vue';
import UILoading from './vue-ui/loading';
import UIModal from './vue-ui/modal';
import UISelection from './vue-ui/selection';
import EventSystem from './utils/EventSystem';

Vue.component('tree-back', UITreeBack);

Vue.component('ui', {
  // Template
  template: `
    <div id="ui">
      <transition name="fade">
        <div v-show="!hidden">
          <ui-head />
          <ui-mid />
          <ui-foot />
          <ui-sidebar />
          <ui-help />
        </div>
      </transition>
      <transition name="fade">
        <div v-show="hidden">
          <ui-tree-side />
          <ui-tree-head />
          <ui-tree-content />
          <ui-tree-sidebar />
        </div>
      </transition>
      <ui-loading />
      <ui-modal />
      <ui-selection />
    </div>
  `,

  // Vars
  props: {},
  data() {
    return {
      hidden: false,
    };
  },
  computed: {},
  // Lifecyle
  created() {
    EventSystem.$on('tree-view-open', () => {
      this.hidden = true;
    });
    EventSystem.$on('tree-view-close', () => {
      this.hidden = false;
    });
  },

  // Methods
  methods: {
  },
  components: {
    'ui-head': UIHead,
    'ui-mid': UIMid,
    'ui-foot': UIFoot,
    'ui-sidebar': UISidebar,
    'ui-help': UIHelp,
    'ui-tree-head': UITreeHead,
    'ui-tree-side': UITreeSide,
    'ui-tree-content': UITreeContent,
    'ui-tree-sidebar': UITreeSidebar,
    'ui-loading': UILoading,
    'ui-modal': UIModal,
    'ui-selection': UISelection,
  },
});

new Vue({
  el: '#root',
  data: {},
});



// WEBPACK FOOTER //
// ./assets/js/source/ui.js